<template>
  <div class="main print-no-padding choose-consult-type">
    <h2 class="is-print-hide title-area">
      <span class="main-title">申请处方</span>
      <span v-if="storeCountInfo" class="store-count-info">{{ storeCountInfo }}</span>
    </h2>
    <el-card class="content">
      <h2>请选择咨询方式</h2>
      <div class="consult-option-wrapper">
        <section
          v-for="(option, index) in consultOption"
          v-show="consultShow(option)"
          :class="['consult-option', option.className]"
          :key="index"
        >
          <div class="consult-option-top">
            <h3>
              <img :src="require(`@/assets/img/${option.icon}.png`)" alt="" />
              {{ option.title }}
            </h3>
            <p class="tip">{{ option.tip }}</p>
          </div>
          <p v-if="option.serviceTime" class="service-time">服务时间：{{ option.serviceTime }}</p>
          <p v-else class="service-time">请在药师上班时间上传</p>
          <div class="now-consult" @click="chooseType(option)">
            <p class="left" v-if="isStoredValueDrugstore && option.price">
              <span class="count">{{ option.price }}</span>
              点/次
            </p>
            <p v-if="option.btnLeftText" class="left">
              <span>{{ option.btnLeftText }}</span>
            </p>
            <p class="right">
              <span>{{ option.btnRightText }}</span>
              <img :src="require('@/assets/img/arrow_right_icon.png')" alt="" />
            </p>
          </div>
        </section>
      </div>
    </el-card>
    <!-- <direction></direction> -->
  </div>
</template>
<script>
import { CONSULT_TYPE } from './constants';
import Fetch from '../../api';
import { baseFormat } from '@fastweb/f2e-utils';
import MessageHint from './components/messageHint';
import { hasPermission } from '@/util';
import { mapGetters, mapMutations, mapState } from 'vuex';
// import direction from '@/components/global/direction';

const baseRole = Constant.RoleList;
const formatTime = time => {
  const [hour, minute] = time.split(':');
  if (hour.length === 1) {
    return `0${hour}:${minute}`;
  }
  return time;
};

export default {
  name: 'chooseConsultType',
  data() {
    return {
      ...CONSULT_TYPE,
      consultOption: [
        // 图文咨询
        {
          className: 'pictrue',
          consultType: CONSULT_TYPE.SIMPLE_CONSULT,
          title: '图文咨询',
          icon: 'simple_consult_icon',
          tip: '线上实时图文咨询',
          serviceTime: '',
          price: null,
          btnRightText: '立即咨询',
          background: 'simple_consult_bg',
          trackId: 'zywzpc-click-ApplyPrescription-Chat'
        },
        // 视频咨询
        {
          className: 'video',
          consultType: CONSULT_TYPE.VIDEO_CONSULT,
          title: '视频咨询',
          icon: 'video_consult_icon',
          tip: '与医生一对一视频连线',
          serviceTime: '',
          price: null,
          btnRightText: '立即咨询',
          background: 'video_consult_bg',
          trackId: 'zywzpc-click-ApplyPrescription-VideoCall'
        },
        // 新版视频咨询
        {
          // 新版视频咨询 先问后诊需求
          className: 'video--new',
          consultType: CONSULT_TYPE.VIDEO_CONSULT,
          title: '视频咨询',
          icon: 'video_consult_icon',
          tip: '与医生一对一视频连线',
          serviceTime: '',
          price: null,
          btnRightText: '立即咨询',
          background: 'video_consult_bg--new',
          nwVideo: true, // 新版视频
          trackId: 'zywzpc-click-ApplyPrescription-VideoCall'
        },
        // 拍照开方
        {
          className: 'photo',
          consultType: CONSULT_TYPE.PHOTO_CONSULT,
          title: '拍照上传',
          icon: 'photo_consult_icon',
          tip: '上传处方图片，提交药师审核',
          serviceTime: '',
          btnLeftText: '已有处方',
          btnRightText: '立即上传',
          price: null,
          background: 'photo_consult_bg'
        }
      ],
      servicePrice: {}
    };
  },
  // components: {
  //   direction
  // },
  computed: {
    ...mapGetters('global', ['allowedConsultTypes']),
    ...mapState('global', ['storeInfo']),
    storeCountInfo() {
      const storeAccoutnInfo = this.$store.getters.storeAccoutnInfo;
      if (storeAccoutnInfo) {
        const { storeType, availableAmount, remainingDays } = storeAccoutnInfo;
        if ([1, 3].includes(storeType)) return `服务剩余：${remainingDays || 0}天`;
        if ([2, 4].includes(storeType)) return `点数余额：${availableAmount || 0}点`;
      }
      return '';
    },
    isStoredValueDrugstore() {
      const roleStore = this.$store.getters.roleStore;
      if (roleStore) {
        const { type } = roleStore;
        return type === 2 || type == 4;
      }
      return false;
    },
    isExpire() {
      const roleStore = this.$store.getters.roleStore;
      if (roleStore) {
        const { isExpire } = roleStore;
        return isExpire;
      }
      return false;
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (vm.isExpire) {
        MessageHint.show({ content: '当前账号不在服务期，请联系销售续约', title: '账号已过期' });
      } else {
        vm.checkAgreement().then(_ => vm.fetchPrescriptionStatus());
      }
    });
  },
  created() {
    this.getWorkingTime();
    this.getServicePrice();
    this.$store.dispatch('global/SETstoreAccoutnInfo');
    this.$store.dispatch('permission/getInfo');
  },
  methods: {
    ...mapMutations('nwVideo', ['SET_NW_VIDEO']),
    consultShow({ nwVideo, consultType }) {
      let { allowsimpleConsult, allowVideoConsult, allowPhotoConsult } = this.allowedConsultTypes;
      const { isHaveDiagnoseBeforeAsk } = this.storeInfo;
      if (consultType == CONSULT_TYPE.SIMPLE_CONSULT) return allowsimpleConsult;
      if (consultType == CONSULT_TYPE.VIDEO_CONSULT) {
        // 有视频权限
        if (allowVideoConsult) {
          return nwVideo ? isHaveDiagnoseBeforeAsk : !isHaveDiagnoseBeforeAsk;
        }
        return false;
      }
      if (consultType == CONSULT_TYPE.PHOTO_CONSULT) return allowPhotoConsult;
    },
    // 上一次咨询校验
    fetchPrescriptionStatus(callback) {
      // 处方申请未结束提示
      const self = this;
      Fetch.getOpenAdvisoryBSide().then(advisory => {
        if (Object.keys(advisory).length > 0) {
          const { advisoryId } = advisory;
          this.$confirm('您上一次的处方申请还未结束，是否继续？', '提示', {
            center: true,
            confirmButtonText: '继续处理',
            cancelButtonText: '确定结束',
            showClose: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            beforeClose(action, instance, done) {
              switch (action) {
                case 'confirm':
                  // 继续处理，跳转im
                  done();
                  self.$router.push(`/chatHome/${advisoryId}`);
                  break;
                case 'cancel':
                case 'close':
                  // 停止问诊
                  Fetch.close_advisory(advisoryId).then(_ => {
                    done();
                    self.$store.dispatch('tagsView/delView', { name: 'applyPrescription', meta: { title: '' } });
                    callback && callback();
                  });
                  break;
              }
            }
          });
        } else {
          self.$store.dispatch('tagsView/delView', { name: 'applyPrescription', meta: { title: '' } });
          callback && callback();
        }
      });
    },
    // 协议校验
    checkAgreement() {
      // 卡控提示
      return Fetch.get_biz_check([Constant.reqBizType.prescription_apply_liability].join(','))
        .then(bizList => {
          if (bizList) {
            let biz = bizList.filter(bizCheck => bizCheck.code === Constant.bizType.liabilityWhiteListOuter);
            if (biz.length > 0) {
              const { busiMobile, busiName } = biz[0].hint;
              MessageHint.show({
                link: this.$checkPower('a,d') ? '/shopManagement' : '',
                content: `
公司负责人/店长需设置药师审方规则，若要通过平台药师审方，请联系公司负责人签署《平台药师审方服务使用承诺函》。如有疑问请联系业务经理：${
                  busiName || ''
                } ${busiMobile || ''}`
              });
              return Promise.reject(new Error('liabilityWhiteListOuter'));
            }
          }
          return Promise.resolve();
        })
        .catch(_ => {});
    },
    async getWorkingTime() {
      let data = await Fetch.get_video_doctor_valid_time();
      const filterRes = data.reduce((obj, item) => {
        return { ...obj, [item.code]: item.value };
      }, {});
      this.consultOption[0].serviceTime = `${filterRes.pictureStartTime} ~ ${filterRes.pictureEndTime}`;
      this.consultOption[1].serviceTime = `${filterRes.videoAmStartTime} ~ ${filterRes.videoPmEndTime}`;
      this.consultOption[2].serviceTime = `${filterRes.videoAmStartTime} ~ ${filterRes.videoPmEndTime}`;
    },
    async getServicePrice() {
      const { picturePrice, videoPrice } = await Fetch.get_service_price();
      this.servicePrice = { picturePrice, videoPrice };
      this.consultOption[0].price = picturePrice;
      this.consultOption[1].price = videoPrice;
      this.consultOption[2].price = videoPrice;
    },
    ifInWorkingTime(tp) {
      return Fetch.get_video_doctor_valid_time()
        .then(timeArr => {
          if (Array.isArray(timeArr)) {
            let start = null;
            let end = null;
            if (tp == CONSULT_TYPE.SIMPLE_CONSULT) {
              const startItem = timeArr.find(item => item.code === 'pictureStartTime') || {};
              const endItem = timeArr.find(item => item.code === 'pictureEndTime') || {};
              start = startItem.value;
              end = endItem.value;
            }
            if (tp == CONSULT_TYPE.VIDEO_CONSULT) {
              [start, end] = timeArr
                .map(time => ['videoAmStartTime', 'videoPmEndTime'].includes(time.code) && time.value)
                .filter(Boolean);
            }

            const currentTime = baseFormat(new Date(), 'HH:mm');
            if (start && end) {
              if (currentTime < formatTime(start) || currentTime > formatTime(end)) {
                this.$message({
                  message: '请在服务时间咨询',
                  type: 'warning'
                });
                return Promise.reject(new Error('overtime'));
              }
            }
          }
          return Promise.resolve();
        })
        .catch(error => {
          return Promise.reject(error);
        });
    },
    async chooseType(option) {
      console.log('option = ', option);
      let type = option.consultType;
      if (type == CONSULT_TYPE.PHOTO_CONSULT) {
        return this.$router.push(`/chooseConsultType/choosePhotoType`);
      }
      try {
        let next = await this.$store.dispatch('global/checkDistance');
        console.log('checkDistance next = ', next);
        if (!next) return;

        // 检查服务时间
        // await this.ifInWorkingTime(type);
        // 检查点数
        await this.checkCoin(type);

        this.SET_NW_VIDEO(option.nwVideo);
        // this.$store.dispatch('video_trtcVideoStore/loginTRTCAccount', {});
        option.trackId &&
          Telescope.trackEvent({
            trackId: option.trackId
          });
        // 老版部分逻辑暂不修改
        this.$router.push(`/chooseConsultType/applyPrescription/${type}`);
      } catch (error) {
        console.log(error);
      }
    },
    // 检查点数
    checkCoin(type) {
      return new Promise((resolve, reject) => {
        let { storeType, availableAmount } = this.$store.getters.storeAccoutnInfo;
        const { picturePrice, videoPrice } = this.servicePrice;
        let price;
        if (type == CONSULT_TYPE.SIMPLE_CONSULT) price = picturePrice;
        if (type == CONSULT_TYPE.VIDEO_CONSULT) price = videoPrice;
        // 非免费用户
        if (storeType == 2 || storeType == 4) {
          // availableAmount = 0;
          if (Number(availableAmount) < Number(price)) {
            let messageObj = {
              content: '余额不足，请联系店长进行充值',
              showConfirmButton: false,
              showCancelButton: false
            };
            let roleList = [baseRole.d];
            if (hasPermission(roleList)) {
              messageObj = {
                content: '余额不足，请尽快进行充值',
                confirmButtonText: '立即充值',
                cancelButtonText: '暂不充值'
              };
            }
            this.$confirm(messageObj.content, '余额不足', {
              customClass: 'confirm',
              center: true,
              ...messageObj
            })
              .then(() => {
                this.$router.push('shopAccount');
              })
              .catch(error => {
                console.log(error);
              });
            reject(new Error('点数不足'));
          }
        }
        resolve();
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    MessageHint.hide();
    next();
  }
};
</script>
<style lang="scss" scoped>
.choose-consult-type {
  font-size: 14px;
  .title-area {
    padding-bottom: 5px;
    .store-count-info {
      margin-left: 8px;
      padding: 2px 8px;
      border-radius: 6px 0px 6px 0px;
      font-size: 12px;
      background-color: #676f70;
      color: #ffffff;
    }
  }
  .content {
    height: 642px;
    h2 {
      color: #bdbdbd;
    }
    .consult-option-wrapper {
      margin-top: 20px;
      display: flex;
      .consult-option {
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        width: 272px;
        height: 344px;
        background: url('~@/assets/img/simple_consult_bg.png');
        padding: 40px 20px 42px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        &:not(:first-child) {
          margin-left: 16px;
        }
        &.video {
          background: url('~@/assets/img/video_consult_bg.png');
          .now-consult {
            background-color: #44a1b8;
          }
        }
        &.video--new {
          background-image: url('~@/assets/img/video_consult_bg--new.png');

          .now-consult {
            background-color: #44a1b8;
          }
        }
        &.photo {
          background-image: url('~@/assets/img/photo_consult_bg.png');
          .now-consult {
            background-color: #4d8fd1;
          }
        }
        .consult-option-top {
          margin-bottom: 80px;
        }
        h3 {
          padding-bottom: 14px;
          > img {
            vertical-align: top;
          }
          color: #242424;
          font-size: 18px;
          font-weight: 800;
        }
        .service-time {
          // padding: 80px 0 60px 0;
          color: #242424;
        }
        .now-consult {
          display: flex;
          justify-content: space-between;
          padding: 9px 12px;
          color: #ffffff;
          background-color: #1e8dff;
          border-radius: 4px;
          margin-top: 60px;
          cursor: pointer;
          .left {
            .count {
              font-weight: bold;
              font-size: 16px;
            }
          }
          .right {
            font-weight: 800;
            > img {
              margin-left: 7px;
              width: 6px;
              height: 10px;
            }
          }
        }
      }
    }
  }
}
</style>
